import "./SelectedToursGridArchitecture.module.css";
import Header from "@/reusable_sections/Header";
import HeroIntroduction from "./sections/HeroIntroduction";
import ToursMasonryGrid from "./sections/ToursMasonryGrid";
import CallToAction from "./sections/CallToAction";
import Footer from "@/reusable_sections/Footer";
export default function SelectedToursGridArchitecturePage() {
  return <div>
      <Header />
      <HeroIntroduction />
      <ToursMasonryGrid />
      <CallToAction />
      <Footer />
    </div>;
}